
























































































import Element from 'element-ui'
import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  UserData, emptyUser, getData, postData, putData, resetPwd, getNewRspblty
} from '@/api/systemManage/user'
import { PopUnitData } from '@/api/heritageUnit/heritageUnit'
import {
  validateIntKey, validatePhone, validateCompare, showVaildMsg, validatePwd
} from '@/configs/validate'
import { getSubDDL } from '@/configs/functions'
import { DDLItem } from '@/api/common/select'
import UnitSearchForm from '@/components/heritageUnit/search/index.vue'
import PageForm from '@/components/pageLayout/form.vue'

import { namespace } from 'vuex-class'
const UserModule = namespace('user')
const DataSourceModule = namespace('dataSource')

const validateUnitList = (rule: any, value: any, callback: (error?: Error) => void) => {
  if (rule.formInfo.UnitList.length == 0) {
    callback(new Error('请添加文保单位'))
  } else {
    callback()
  }
}
const getFormRules = (id: number, form: { [key: string]: string | any }) => {
  return {
    'RspbltyInfo.ResponsibilityId': [
      {
        required: true,
        validator: validateIntKey('请选择责任人分类'),
        trigger: 'change'
      }
    ],
    UnitList: [{ required: true, validator: validateUnitList, formInfo: form, trigger: 'change', message: '请添加文保单位' }],
    UserName: [
      { required: true, message: '用户名不能为空', trigger: 'blur' }
    ],
    DisplayName: [
      { required: true, message: '昵称不能为空', trigger: 'blur' }
    ],
    Email: [
      { required: true, message: '邮箱不能为空', trigger: 'blur' },
      { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
    ],
    Password: [
      { required: true, validator: validatePwd, trigger: 'blur' }
    ],
    ConfirmPassword: [
      { required: true, min: 8, message: '请输入确认密码' },
      { validator: validateCompare('Password', '两次输入的密码不一致', form), trigger: 'blur' }
    ],
    CellPhone: [
      { required: true, message: '手机不能为空', trigger: 'blur' },
      { validator: validatePhone, trigger: 'blur' }
    ]
  }
}
@Component({
  components: {
    PageForm,
    UnitSearchForm
  }
})
export default class UnitRspbltyForm extends Vue {
  @UserModule.Getter('userInfo')
  public curUser!: UserData
  public collapseNames = ['base']

  public emptyForm: UserData = emptyUser
  public form = Object.assign({}, this.emptyForm)
  public loading = false
  public rules = getFormRules(0, this.form)
  public responsibilityList: DDLItem[] = []

  // dynamic component
  public $refs!: {
    formCtrl: PageForm
    unitSearchCtrl: UnitSearchForm
  }
  public created() {
    this.fetchSource()
    this.fetchData()
  }
  public mounted() {
    //回调函数
    window.eventBus.$on('submitUnitSearchForm', (data: PopUnitData[]) => {
      this.getUnit(data)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('submitUnitSearchForm')
  }
  //#region 弹窗查询文保单位
  public openUnitSearch() {
    window.eventBus.$emit('openUnitSearchForm')
  }
  public getUnit(data: PopUnitData[]) {
    let f = this.form
    data.forEach((e: any, i: number) => {
      const index: number = this.form.UnitList.findIndex((v: any) => v.UnitId === e.UnitId)
      if (index < 0) {
        this.form.UnitList.push({
          Id: 0,
          UnitId: e.UnitId,
          UnitCode: e.UnitCode,
          UnitName: e.UnitName,
          UserId: f.Id,
          NewUserId: 0,
          NewDate: new Date()
        })
      }
    })
    this.$refs.formCtrl.validateField('UnitList')
  }
  public closeUnitSearch() {
    console.log('这里是查询文保单位组件关闭后回传的事件')
  }
  public delUnit(index: number) {
    this.$confirm('确定要删除吗?', '请确认', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.form.UnitList.splice(index, 1)
        this.$refs.formCtrl.validateField('UnitList')
      })
      .catch(() => {
        this.$message({ type: 'info', message: '已取消操作' })
      })
  }
  //#endregion

  public onSubmit() {
    const promist =
      this.form.Id > 0
        ? putData(this.form.Id, this.form)
        : postData(this.form)
    promist.then((response: { data: any }) => {
      const data = response.data
      const msg = this.form.Id > 0 ? '保存' : '创建'
      if (data && !data.IsError) {
        this.$message({
          message: `${this.form.UserName}${msg}成功`,
          type: 'success'
        })
        this.$router.push({ path: '/UnitRspblty' })
      } else {
        this.$message({
          dangerouslyUseHTMLString: true, message: `${data.Message}`, type: 'warning'
        })
        console.log(response)
      }
    })
  }
  @DataSourceModule.Getter('dataSource')
  public dataSource!: any
  public fetchSource() {
    const data = Object.assign({}, this.dataSource)
    if (data) {
      this.responsibilityList = data.responsibilityList
    }
  }
  public fetchUser(id: number) {
    if (id > 0) {
      getData(id).then((response: { data: any }) => {
        if (response.data) {
          this.form = response.data
          this.form.Password = ''
          this.form.ConfirmPassword = ''
          this.rules = getFormRules(this.form.Id, this.form)
        }
      })
    } else {
      getNewRspblty().then((response: { data: any }) => {
        if (response.data) {
          this.form = response.data
          this.form.Password = ''
          this.form.ConfirmPassword = ''
          this.rules = getFormRules(this.form.Id, this.form)
          this.$refs.formCtrl.clearValidate()
          this.loading = false
        }
      })
    }
  }
  public fetchData() {
    const id = +this.$router.currentRoute.params.id || 0
    this.fetchUser(id)
  }
  public onCancel() {
    /*this.$message({
      message: 'cancel!',
      type: 'warning'
    })*/
    //这里要根据页面from来判断返回到哪个页面
    this.$router.go(-1)
    // this.$router.push({ path: '/User' })
  }
  @Watch('$route')
  public onRouteChange(route: any) {
    this.fetchData()
  }
}
